<div class="row">
  <div class="col">
    <span *ngIf="showEditButton">
      <a
        title="Edit"
        *ngIf="!editWithModal && !appDictionary && !eventRegistration"
        class="btn btn-sm btn-outline-purple mx-1"
        [routerLink]="displayValue.data.editRoutePath + displayValue.data._id"
      >
        <i-feather name="edit"></i-feather>
      </a>
      <a
        title="Edit"
        *ngIf="editWithModal"
        class="btn btn-sm btn-outline-purple mx-1"
        (click)="onActionClick('edit', displayValue.data._id, '')"
      >
        <i-feather name="edit"></i-feather>
      </a>
      <a
        title="{{ 'EDIT' | translate }}"
        *ngIf="!editWithModal && appDictionary"
        class="btn btn-sm btn-outline-purple mx-1"
        [routerLink]="
          displayValue.data.editRoutePath +
          displayValue.data.variableName +
          '/' +
          displayValue.data.system +
          '/' +
          getEncodeValue(displayValue.data.english) +
          '/' +
          getEncodeValue(displayValue.data.hebrew) +
          '/' +
          getEncodeValue(displayValue.data.arabic)
        "
      >
        <i-feather name="edit"></i-feather>
      </a>
      <a
        title="{{ 'EDIT' | translate }}"
        *ngIf="!editWithModal && eventRegistration"
        class="btn btn-sm btn-outline-purple mx-1"
        [routerLink]="displayValue.data.editRoutePath + displayValue.data._id + '/' + displayValue.data.nameHe"
      >
        <i-feather name="edit"></i-feather>
      </a>
    </span>
    <button
      title="Delete"
      *ngIf="showDeleteButton"
      class="btn btn-sm btn-outline-danger mx-1"
      (click)="onActionClick('delete', displayValue.data._id, displayValue)"
    >
      <i-feather name="trash-2"></i-feather>
    </button>
    <button
      title="View"
      *ngIf="showViewButton"
      class="btn btn-sm btn-outline-purple mx-1"
      (click)="onActionClick('view', displayValue.data._id, displayValue)"
    >
      <i-feather name="eye"></i-feather>
    </button>
    <button
      title="Sync"
      *ngIf="showSyncButton"
      class="btn btn-sm btn-outline-primary mx-1"
      (click)="onActionClick('sync', displayValue.data._id, displayValue)"
    >
      <i-feather name="refresh-cw"></i-feather>
    </button>
  </div>
</div>
